module.exports = __webpack_public_path__ + "static/media/imgCard04.c15c0057.png";